module.exports = __webpack_public_path__ + "img/recon_reports_active.61b24835.svg";